import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=1f5e159c&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&id=1f5e159c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e159c",
  null
  
)

export default component.exports